var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import _ from 'lodash';
import assert from 'assert';

import DataItem from './DataItem';
import PropertyInfo from './PropertyInfo';

var ScheduledItem = function () {
    function ScheduledItem(scheduleDescriptor, propertyInfos, onChange, itemOnChange) {
        var _this = this;

        _classCallCheck(this, ScheduledItem);

        assert(Array.isArray(propertyInfos) && propertyInfos.every(function (pi) {
            return pi instanceof PropertyInfo;
        }));

        this._descriptor = scheduleDescriptor;
        this._properties = propertyInfos;
        this._onChange = typeof onChange === 'function' ? onChange : _.noop;
        this._itemOnChange = typeof itemOnChange === 'function' ? itemOnChange : _.noop;
        this._hasScheduleChanged = false;

        this._id = typeof scheduleDescriptor.itemNumber === 'number' ? scheduleDescriptor.itemNumber : null;
        this._items = _(scheduleDescriptor.itemData).map(function (item, name) {
            var matchingProp = _.find(_this._properties, function (prop) {
                return prop.getName() === name;
            });

            assert(matchingProp, 'No matching property found for ' + name);
            return new DataItem(item, matchingProp, _this._itemOnChange);
        }).sortBy(function (item) {
            return item.getPropertyInfo().getOrder();
        }).valueOf();

        assert(this._items.length > 0, 'Expected scheduled item to have data items');
    }

    _createClass(ScheduledItem, [{
        key: 'getId',
        value: function getId() {
            return this._id;
        }
    }, {
        key: 'getDataItems',
        value: function getDataItems() {
            return this._items;
        }
    }, {
        key: '_findIn',
        value: function _findIn(array) {
            assert(Array.isArray(array));
            return array.indexOf(this._descriptor);
        }
    }, {
        key: 'findProperty',
        value: function findProperty(dataItem) {
            assert(dataItem instanceof DataItem);
            return _.find(this._properties, function (prop) {
                return dataItem.getName() === prop.getName();
            });
        }
    }, {
        key: 'findItemByProperty',
        value: function findItemByProperty(dataItem) {
            assert(dataItem instanceof DataItem);
            return _.find(this._items, function (item) {
                return dataItem.getName() === item.getName();
            });
        }
    }, {
        key: 'describe',
        value: function describe() {
            return this._descriptor;
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            return this.getDataItems().every(function (item) {
                return item.isValid();
            });
        }
    }, {
        key: 'isDrafted',
        value: function isDrafted() {
            return this.getDataItems()[0].isDrafted();
        }
    }, {
        key: 'draft',
        value: function draft() {
            this.getDataItems().forEach(function (item) {
                return item.draft();
            });
        }
    }, {
        key: 'commit',
        value: function commit() {
            this.getDataItems().forEach(function (item) {
                return item.commit();
            });
            if (_.some(this.getDataItems(), function (item) {
                return item.getChangedStatus();
            })) {
                this.getDataItems().forEach(function (item) {
                    return item.resetChangedStatus();
                });
                this._hasScheduleChanged = true;
                this._onChange();
            }
        }
    }, {
        key: 'undo',
        value: function undo() {
            this.getDataItems().forEach(function (item) {
                return item.undo();
            });
        }
    }, {
        key: 'asCommited',
        value: function asCommited() {
            if (this._asCommited) {
                return this._asCommited;
            }

            var CurrentScheduledItem = this.constructor;
            this._asCommited = new CurrentScheduledItem(this.describe(), this._properties, this._onChange, this._itemOnChange);
            return this.asCommited();
        }
    }, {
        key: 'getChangedStatus',
        value: function getChangedStatus() {
            return this._hasScheduleChanged;
        }
    }, {
        key: 'resetChangedStatus',
        value: function resetChangedStatus() {
            this._hasScheduleChanged = false;
        }
    }]);

    return ScheduledItem;
}();

export default ScheduledItem;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/models/schedules/ScheduledItem.js
// module id = 806
// module chunks = 0